import { HubConnectionState } from "@microsoft/signalr";

import { translations } from "@/shared/localization/translations";

export class ConnectionState {
    private static delay?: number;
    public static disabled = false;

    public static setBySignalR(state: HubConnectionState) {
        if (ConnectionState.disabled) return;

        if (state === HubConnectionState.Connected) ConnectionState.hide(translations.enums.connectionState[state]);
        else ConnectionState.show(translations.enums.connectionState[state]);
    }

    public static show(msg: string) {
        if (ConnectionState.delay !== undefined) clearTimeout(ConnectionState.delay);

        ConnectionState.delay = window.setTimeout(() => {
            let el = $(".app > .connectionstate");
            if (el.length === 0) {
                el = $('<div class="connectionstate" />').prependTo($(".app"));
                el[0].offsetHeight;
            } else el.removeClass("ok").stop(true, false);

            el.html(msg);

            if (!el.hasClass("shown")) el.addClass("shown");
        }, 200);
    }

    public static hide(withMsg?: string) {
        if (ConnectionState.delay !== undefined) clearTimeout(ConnectionState.delay);

        const el = $(".app > .connectionstate");
        if (el.length === 0) return;

        if (withMsg !== undefined) el.html(withMsg);

        el.stop(true, false)
            .addClass("ok")
            .delay(2000)
            .queue((a) => {
                el.removeClass("shown")
                    .delay(400)
                    .queue((e) => {
                        el.remove();
                        e();
                    });

                a();
            });
    }
}
